import Button from '@ui/Button';
import React, { FC, useEffect, useState } from 'react';
import { I18n } from 'react-redux-i18n';
import request from 'superagent';
import styles from './styles.module.scss';

interface Props {
  onComplete: () => void;
}

const Launcher: FC<Props> = ({ onComplete }) => {
  const [link, setLink] = useState('');

  useEffect(() => {
    const navigator: any = window.navigator || {};
    const { platform } = navigator.userAgentData || navigator,
      macosPlatforms = ['macOS', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];

    const os = macosPlatforms.indexOf(platform) !== -1 ? 'mac' : 'win';
    request.get(`/mc/download/${os}`).then(res => setLink(res.body.link));
  });

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <span className={styles.stepTitle}>
            {I18n.t('onboarding.launcher.title')}
          </span>
          <p className={styles.stepHint}>
            {I18n.t('onboarding.launcher.info')}
          </p>
        </div>
        <div className={styles.right}>
          <a href={link} rel="_blank">
            <Button className={styles.action} color="green">
              {I18n.t('onboarding.launcher.download')}
            </Button>
          </a>
          <div className={styles.downloadInfo}>
            {I18n.t('onboarding.launcher.downloadInfo')}
          </div>
          <Button className={styles.action} color="white" onClick={onComplete}>
            {I18n.t('onboarding.launcher.next')}
          </Button>
        </div>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.left}>{I18n.t('onboarding.launcher.help')}</div>
        <div className={styles.right}>
          <video
            width="100%"
            loop
            autoPlay
            controls
            src="/video/launcher-tutorial.mp4"
          />
        </div>
      </div>
    </>
  );
};

export default Launcher;
